var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('nav', {
    staticClass: "navbar is-fixed-top is-primary",
    attrs: {
      "aria-label": "main navigation",
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/admin/dashboard"
    }
  }, [_c('strong', [_vm._v("OCM 2026 Admin")])]), _c('a', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.navigationDrawerOpen
    },
    attrs: {
      "aria-expanded": "false",
      "aria-label": "menu",
      "data-target": "navbarBasicExample",
      "role": "button"
    },
    on: {
      "click": function click($event) {
        _vm.navigationDrawerOpen = !_vm.navigationDrawerOpen;
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.navigationDrawerOpen
    },
    attrs: {
      "id": "navbarBasicExample"
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/regimento"
    }
  }, [_vm._v("Regimento")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/provas"
    }
  }, [_vm._v("Provas")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/published-students"
    }
  }, [_vm._v("Lista de inscritos")]), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/premiacao"
    }
  }, [_vm._v("Premiação")])], 1), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "buttons"
  }, [_c('a', {
    staticClass: "button is-outlined is-light",
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v("Sair")])])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };